const TopBar = () => {
    return (

        <div className="container-fluid bg-dark p-0">
            <div className="row gx-0 d-none d-lg-flex">

                <div className="col-lg-5 px-5 text-end">
                    <div className="h-100 d-inline-flex align-items-center me-4">

                    </div>

                </div>
            </div>
        </div>
    )
}

export default TopBar;